<template>
  <Modal
    :visible="showModel"
    :ok-text="needCustomerService ? $t('联系客服') : $t('查看更多')"
    :cancel-text="null"
    :close-on-click-modal="true"
    @on-ok="toExpDetailPage"
    @on-close="cancel"
    @close="cancel"
  >
    <template #icon>
      <SvgIcon class="w64 h64" icon="64-Filled-Popup_Alert" />
    </template>
    <div class="fz16 text-text1 weight-700 lh24 text-align-center">
      {{ title }}
    </div>
    <div class="fz14 text-text1 weight-500 lh22 text-align-center mt4">
      {{ sub }}
    </div>
  </Modal>
</template>
<script lang="ts" setup>
import { i18n } from '@/lang/i18n';
import { isPC } from '@/utils/tools';
import SvgIcon from '@c/common/Icon.vue';

const emit = defineEmits(['ok', 'close']);

const props = defineProps({
  type: {
    type: [Number, String],
    default: 0
  },
  title: {
    type: String,
    default: ''
  },
  sub: {
    type: String,
    default: ''
  },
  /** 需要联系客服 */
  needCustomerService: {
    type: Boolean,
    default: false
  }
});

const showModel = ref(false);
const isPCPlat = isPC();

const cancel = () => {
  showModel.value = false;
  emit('close');
};

const toExpDetailPage = () => {
  if (props.needCustomerService) {
    if (typeof window.zc === 'function') {
      window.zc('frame_status');
      return;
    }
  }
  const path = isPCPlat ? '/user-exp' : '/h5/user-exp';
  window.location.href = `/${i18n.global.locale.value}${path}`;
};

onMounted(() => {
  showModel.value = true;
});

</script>
<style lang="scss" scoped>

</style>
